/**
 * MineraliA: precarga la página de un enlace interno cuando hay intención clara de visitarla
 * (cursor encima 200 ms o inicio del toque). Sólo descarga el HTML; no ejecuta nada.
 *
 * Se usa una regla de lista con una sola URL en lugar de reglas de documento: con reglas de
 * documento Chrome evalúa todos los enlaces del home al cargar (tarea larga de ~400 ms en escritorio).
 * Sin Speculation Rules (Firefox) usa <link rel="prefetch">; Safari no precarga.
 */
const HOVER_DELAY_MS = 200;
const EXCLUDED_PATH = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:cart|checkouts?|account|apps|services|cdn|admin)(?:\/|$)/i;
const supportsRules = Boolean(HTMLScriptElement.supports?.('speculationrules'));
const prefetched = new Set();
let hoverTimer = 0;

function canPrefetch() {
  const connection = navigator.connection;
  return !(connection && (connection.saveData || /2g/.test(connection.effectiveType || '')));
}

function targetUrl(event) {
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
  if (!link || link.target === '_blank' || link.hasAttribute('download') || link.hasAttribute('data-no-prefetch')) return null;

  const url = new URL(link.href, location.href);
  if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || EXCLUDED_PATH.test(url.pathname)) return null;
  url.hash = '';
  if (url.pathname === location.pathname && url.search === location.search) return null;
  return prefetched.has(url.href) ? null : url.href;
}

function prefetch(href) {
  prefetched.add(href);
  if (supportsRules) {
    const script = document.createElement('script');
    script.type = 'speculationrules';
    script.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [href] }] });
    document.head.append(script);
  } else {
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.append(link);
  }
}

if (canPrefetch()) {
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const href = targetUrl(event);
    if (!href) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(() => prefetch(href), HOVER_DELAY_MS);
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType === 'mouse' && event.target instanceof Element && event.target.closest('a[href]')) clearTimeout(hoverTimer);
  });

  document.addEventListener(
    'touchstart',
    (event) => {
      const href = targetUrl(event);
      if (href) prefetch(href);
    },
    { passive: true }
  );
}
